import { useEffect, useState } from 'react'
import { initializeApp } from 'firebase/app'
import { getDatabase, ref } from 'firebase/database'
import { getGoals } from './api/api'
import { GoalData } from './data'
import Button from './components/Button'
import Modal from './components/Modal'
import background from './background.png'
import './App.css'

const app = initializeApp({
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
})

function App() {
    const [goals, setGoals] = useState<GoalData[]>([])
    const [selectedGoal, setSelectedGoal] = useState<GoalData>()

    // retrieval of data
    const dbRef = ref(getDatabase(app))

    useEffect(() => {
        getGoals(dbRef)
            .then((goals) => {
                setGoals(goals)
            })
            .catch((error) => {
                console.error(error)
            })
    }, [dbRef])

    function closeModal() {
        setSelectedGoal(undefined)
    }

    return (
        <div className="app">
                <div className="background">
                    <div className="graphicsContainer">
                        {goals.map((data, index) => (
                            <Button
                                key={index}
                                data={data}
                                selected={data.id === selectedGoal?.id}
                                setSelected={(selected: boolean) => {
                                    if (!selected) setSelectedGoal(undefined)
                                    else setSelectedGoal(data)
                                }}
                            />
                        ))}
                        <Modal
                            data={selectedGoal}
                            showModal={selectedGoal !== undefined}
                            close={closeModal}
                        />
                        <img className="background-img" src={background} alt="DSSD Global" />
                    </div>
                </div>
        </div>

    )
}

export default App
